import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('commandRoleMapCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/access/command-role-map'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.commandRoleMapCache,
    cacheName: 'commandRoleMap'
  })
);
